/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginResponse } from "../models/LoginResponse";
import type { RegisterResponse } from "../models/RegisterResponse";
import type { TokenResponse } from "../models/TokenResponse";
import type { CancelablePromise } from "../../core/CancelablePromise";
import { OpenAPI } from "../../core/OpenAPI";
import { request as __request } from "../../core/request";
export class AuthenticationService {
  /**
   * Register a new user
   * Creates a new user account
   * @param requestBody
   * @returns RegisterResponse User created successfully
   * @throws ApiError
   */
  public static postAuthRegister(requestBody: {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    companyName?: string;
    phoneNumber?: string;
    jobTitle?: string;
    marketingConsent?: boolean;
    registrationSource?: "website" | "app" | "referral" | "social";
  }): CancelablePromise<RegisterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/signup",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        409: `Email already exists`,
      },
    });
  }
  /**
   * Confirm signup
   * Confirm signup after registration
   * @param requestBody
   * @returns RegisterResponse User created successfully
   * @throws ApiError
   */
  public static postAuthConfirmSignUp(requestBody: {
    email: string;
    code: string;
    registrationSource?: "website" | "app" | "referral" | "social";
  }): CancelablePromise<RegisterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/confirm-signup",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Invalid input`,
        409: `Email already exists`,
      },
    });
  }
  /**
   * User login
   * Authenticates a user and returns a JWT token
   * @param requestBody
   * @returns LoginResponse Login successful
   * @throws ApiError
   */
  public static postAuthLogin(requestBody: {
    email: string;
    password: string;
    rememberMe?: boolean;
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/signin",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid credentials`,
        403: `Account locked or requires verification`,
        429: `Too many login attempts`,
      },
    });
  }

  /**
   * User Forgot Password
   * Send OTP email to user for password reset
   * @param requestBody
   * @returns LoginResponse Login successful
   * @throws ApiError
   */
  public static postAuthResendOTP(requestBody: {
    email: string;
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/resend-verify-code",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid credentials`,
        403: `Account locked or requires verification`,
        429: `Too many login attempts`,
      },
    });
  }
  public static postAuthForgotPassword(requestBody: {
    email: string;
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/forgot-password",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid credentials`,
        403: `Account locked or requires verification`,
        429: `Too many login attempts`,
      },
    });
  }
  /**
   * User Confirm Forgot Password
   * Confirm OTP and reset password
   * @param requestBody
   * @returns LoginResponse Login successful
   * @throws ApiError
   */
  public static postAuthConfirmForgotPassword(requestBody: {
    email: string;
    code: string;
    password: string;
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/confirm-forgot-password",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid credentials`,
        403: `Account locked or requires verification`,
        429: `Too many login attempts`,
      },
    });
  }
  /**
   * Refresh authentication token
   * Issues a new JWT token using a refresh token
   * @param requestBody
   * @returns TokenResponse Token refreshed successfully
   * @throws ApiError
   */
  public static postAuthRefreshToken(requestBody: {
    refreshToken: string;
  }): CancelablePromise<TokenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/auth/refresh-token",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid refresh token`,
      },
    });
  }
  /**
   * User logout
   * Invalidates the current JWT token
   * @returns any Logout successful
   * @throws ApiError
   */
  public static postAuthLogout(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/auth/logout",
      errors: {
        401: `Unauthorized`,
      },
    });
  }

   /**
   * User Confirm Forgot Password
   * Confirm OTP and reset password
   * @param requestBody
   * @returns LoginResponse Login successful
   * @throws ApiError
   */
  public static postAuthResetPassword(requestBody: {
    email: string;
    session?: string;
    new_password: string;
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/open/v1/complete-new-password",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Invalid credentials`,
        403: `Account locked or requires verification`,
        429: `Too many login attempts`,
      },
    });
  }
}
